// /sign-in — the Join landing with the sign-in module open. Rendered by the
// _landing layout (JoinLanding reads the path); this route owns the path and
// validates the same search params /auth/login accepts, which JoinLanding reads
// and forwards to the sign-in form (invite bounce token, drift-final reason).
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const signInSearchSchema = z.object({
  pendingInviteToken: z.string().min(1).optional(),
  from: z.string().optional(),
  reason: z.enum(['deactivated_expired', 'restricted']).optional(),
});

export const Route = createFileRoute('/_public/_landing/sign-in')({
  validateSearch: signInSearchSchema.parse,
  component: () => null,
});
